export function isDecimal(value) {
  let text = value ? value.toString() : ''
  return text.indexOf('.') !== -1
}

export function isInteger(value) {
  let text = value ? value.toString() : ''
  return text.indexOf('.') === -1
}

export function countDecimals(value) {
  let text = value ? value.toString() : ''
  // verify if number 0.000005 is represented as "5e-6"
  if (text.indexOf('e-') > -1) {
    let [trail] = text.split('e-')
    return parseInt(trail, 10)
  }
  // count decimals for number in representation like "0.123456"
  if (Math.floor(value) !== value) {
    return value.toString().split('.')[1].length || 0
  }
  return false
}
